export function PageHero({ eyebrow, title, subtitle }: { eyebrow: string; title: string; subtitle?: string }) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10" style={{ background: "var(--gradient-soft)" }} />
      <div className="container-1120 py-16 md:py-24 text-center">
        <span className="eyebrow">{eyebrow}</span>
        <h1 className="mt-4 text-4xl md:text-5xl font-bold text-ink">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">{subtitle}</p>}
      </div>
    </section>
  );
}